import request from "@/utils/request";
import baseUrl from "@/utils/base-url";
//精简500题目
export function getFine(data) {
  return request({
    url:baseUrl.base+'/sequence',
    method: "get",
    params: data
  })
}
//检查用户VIP
export function isVip(data) {
  return request({
    url:baseUrl.base+'/isVip',
    method: "get",
    params: data
  })
}
//上报已做习题（新）
export function addDid(data) {
  return request({
    url:baseUrl.base+'/addDid',
    method: "post",
    params: data
  })
}
//上报练习位置（新）
export function exercisePosition(data) {
  return request({
    url:baseUrl.base+'/exercisePosition',
    method: "post",
    params: data
  })
}
//清空练习记录（新）
export function delDid(data) {
  return request({
    url:baseUrl.base+'/delDid',
    method: "post",
    params: data
  })
}
